import api from './api';

export const billingService = {
  /**
   * Get available plans
   */
  async getPlans() {
    const response = await api.get('/billing/plans');
    return response.data;
  },

  /**
   * Get current subscription
   */
  async getSubscription() {
    const response = await api.get('/billing/subscription');
    return response.data;
  },

  /**
   * Create checkout session
   */
  async createCheckoutSession(planId, billingPeriod = 'monthly', paymentProvider = 'stripe') {
    const response = await api.post('/billing/checkout/multi', {
      plan_id: planId,
      billing_period: billingPeriod,
      payment_provider: paymentProvider,
      success_url: `${window.location.origin}/billing?success=true`,
      cancel_url: `${window.location.origin}/billing?canceled=true`,
    });
    return {
      ...response.data,
      url: response.data.approval_url || response.data.url,
    };
  },

  /**
   * Capture a PayPal order after redirect
   */
  async capturePayPalOrder(orderId) {
    const response = await api.post('/billing/paypal/capture', {
      order_id: orderId,
    });
    return response.data;
  },

  /**
   * Cancel subscription
   */
  async cancelSubscription() {
    const response = await api.post('/billing/cancel');
    return response.data;
  },

  /**
   * Get billing portal URL
   */
  async getBillingPortalUrl() {
    const response = await api.get('/billing/portal-url', {
      params: {
        return_url: `${window.location.origin}/billing`,
      },
    });
    return response.data;
  },

  /**
   * Get billing history
   */
  async getHistory(limit = 10) {
    const response = await api.get('/billing/history', {
      params: { limit },
    });
    return response.data;
  },
};

export default billingService;
